import { Box } from "@chakra-ui/react";
import React, { useContext, useMemo, useRef } from "react";

export interface PageContainerContextValue {
  bottomContainerRef: React.RefObject<HTMLDivElement>;
}

export const PageContainerContext =
  React.createContext<PageContainerContextValue>(undefined as never);

export const usePageContainerBottomRef = () => {
  const context = useContext(PageContainerContext) as
    | PageContainerContextValue
    | undefined;
  if (!context) {
    throw new Error("Missing <PageContainer>");
  }
  return context.bottomContainerRef;
};

const PageContainer: React.FC<React.PropsWithChildren> = ({ children }) => {
  const existingContext = useContext(PageContainerContext) as
    | PageContainerContextValue
    | undefined;
  if (existingContext) {
    throw new Error("PageContainer can only be used once per page");
  }
  const bottomContainerRef = useRef<HTMLDivElement>(null);
  const value = useMemo<PageContainerContextValue>(
    () => ({ bottomContainerRef }),
    [bottomContainerRef],
  );
  return (
    <>
      <PageContainerContext.Provider value={value}>
        <Box
          display="flex"
          flexDirection="row"
          flex="1"
          minWidth={0}
          minHeight={0}
        >
          {children}
        </Box>
      </PageContainerContext.Provider>
      <Box ref={bottomContainerRef} />
    </>
  );
};

export default PageContainer;
